import { useIsBannerHidden } from 'hooks/useIsBannerHidden'
import { Route, Switch } from 'react-router'
import NotificationBanner from '../Header/HeaderBanners/NotificationBanner'

const ROUTES_WITH_NO_NOTIFICATION_BANNER: Array<string> = [
  '/:regionCode/corporate-events/:eventId',
  '/:regionCode/corporate-events/:eventId/faq',
  '/:regionCode/corporate-events/:eventId/other-activities',
  '/:regionCode/corporate-events/:eventId/flights',
  '/:regionCode/corporate-events/:eventId/accommodation',
  '/:regionCode/corporate-events/:eventId/things-to-know',
  '/:regionCode/corporate-events/:eventId/register',
]

const HELP_NOTIFICATION_BANNER_ROUTES: Array<string> = [
  '/:regionCode/terms-and-conditions',
  '/:regionCode/account/my-escapes',
  '/:regionCode/account/my-escapes/order/:orderId',
]

function NotificationBannerRoutes() {
  const isHidden = useIsBannerHidden('notificationBanner')

  if (isHidden) {
    return null
  }

  return <Switch>
    <Route path={ROUTES_WITH_NO_NOTIFICATION_BANNER} />
    <Route path={HELP_NOTIFICATION_BANNER_ROUTES}>
      <NotificationBanner slug="help-with-banner" />
    </Route>
    <Route component={NotificationBanner} />
  </Switch>
}

export default NotificationBannerRoutes
